import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

export const SkuMessageWarn = ({ message }: any) => {
    return (
        <Alert variant="warning" className="ml-4 mr-4">
            <div className="text-center">{message}</div>
        </Alert>
    )
}

SkuMessageWarn.propTypes = {
    message: PropTypes.string.isRequired,
}
